<script setup lang="ts">
import roles from '@/config/roles.json'
const userStore = useUserStore()
const { doLogout } = userStore
import { IconUser, IconSettings, IconLogout } from '@tabler/icons-vue'
const { t } = useI18n()
const getColorFromLetter = () => {
  try {
    const letter = userStore.getInitials().split('')[0]
    const letters = 'ZYXWVUTSRQPÑNMLKJIHGFEDCBA'
    const index = letters.indexOf(letter.toUpperCase())
    if (index === -1) {
      throw new Error('La letra no es válida')
    }
    const hue = (index / letters.length) * 360
    return `hsl(${hue}, 100%, 40%)`
  } catch (error) {
    console.error(error)
  }
}
</script>
<template>
  <CDropdown variant="nav-item" :auto-close="false">
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CAvatar
        :style="{ backgroundColor: getColorFromLetter() }"
        text-color="white"
        style="border-radius: 20%; width: 24px; height: 24px"
      >
        {{ userStore.getInitials() }}
      </CAvatar>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="dropdown-header bg-light dark:bg-opacity-10 py-2">
        {{ t('User') }}
      </CDropdownHeader>
      <router-link to="/user/settings" class="text-decoration-none">
        <CDropdownItem>
          <IconUser stroke-width="1" size="24" class="mb-1" />
          {{ t('Settings') }}
        </CDropdownItem>
      </router-link>
      <CDropdownHeader
        component="h6"
        class="dropdown-header bg-light dark:bg-opacity-10 py-2"
        v-if="userStore.userHasRole(roles.sudo.name) || userStore.userHasRole(roles.client.name)"
      >
        {{ t('Customer') }}
      </CDropdownHeader>
      <router-link
        to="/account/settings"
        class="text-decoration-none"
        v-if="userStore.userHasRole(roles.sudo.name) || userStore.userHasRole(roles.client.name)"
      >
        <CDropdownItem>
          <IconSettings stroke-width="1" size="24" class="mb-1" />

          {{ t('Settings') }}
        </CDropdownItem>
      </router-link>

      <!--
      <CDropdownItem>
        <CIcon icon="cil-dollar" /> Payments
        <CBadge color="secondary" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-file" /> Projects
        <CBadge color="primary-gradient" class="ms-auto">{{
          itemsCount
        }}</CBadge>
      </CDropdownItem>
      <CDropdownDivider />
      <CDropdownItem>
        <CIcon icon="cil-shield-alt" /> Lock Account
      </CDropdownItem> -->
      <li>
        <div class="d-grid p-2">
          <CButton @click="doLogout()" color="primary" size="sm">
            {{ t('Logout') }}
            <IconLogout size="16" />
          </CButton>
        </div>
      </li>
    </CDropdownMenu>
  </CDropdown>
</template>
